const isNewTabNavigationEvent = (event) => {
  return Boolean(event?.metaKey || event?.ctrlKey || event?.button === 1 || event?.nativeEvent?.button === 1);
};

export default isNewTabNavigationEvent;
